/* kitsters-header.js */

(function () {

  const section = document.querySelector('.kh-hdr-section');
  const annBar  = document.querySelector('.kh-ann');

  // ── Announcement rotator ──────────────────────────────────────
  // Guards the old bare setInterval on two counts: it ignored
  // prefers-reduced-motion (a rotating banner is exactly the kind of unbidden
  // movement that setting exists to stop), and it kept swapping slides while the
  // tab was in the background, so returning to the tab landed on an arbitrary slide.
  const slides = document.querySelectorAll('.kh-ann__slide');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (slides.length > 1 && !reduceMotion.matches) {
    let cur = 0;
    setInterval(() => {
      if (document.hidden) return;
      slides[cur].classList.remove('is-active');
      cur = (cur + 1) % slides.length;
      slides[cur].classList.add('is-active');
    }, 4000);
  }

  // ── Announcement-bar height → --kh-ann-h ──────────────────────
  // The sticky offset in kitsters-header.css is calc(-1 * var(--kh-ann-h)), so this
  // value is what makes the ann bar scroll away while the header pins. It is
  // measured rather than hardcoded because the bar's real height moves with width
  // (36px desktop, 32px mobile, 41px at 320px where the copy wraps to two lines)
  // and with whatever text the owner sets in the theme editor.
  // ── Scroll shadow + compact header ───────────────────────────
  // `.is-scrolled` must mean "the announcement bar has scrolled away and the header
  // is pinned alone" - the state the compact-height, backdrop-blur and megapanel-top
  // rules are all written against.
  //
  // It deliberately watches a sentinel parked at document offset --kh-ann-h rather
  // than watching the ann bar itself. Once the section is pinned the ann bar stops
  // moving at exactly bottom = 0, edge-touching the viewport forever, and Chromium
  // keeps reporting that zero-area overlap as intersecting - so observing the bar
  // directly meant the class never applied at any scroll depth (measured).
  if (section) {
    const sentinel = document.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.cssText = 'position:absolute;left:0;width:1px;height:1px;pointer-events:none';
    document.body.prepend(sentinel);

    const syncAnnHeight = () => {
      const h = annBar ? Math.round(annBar.getBoundingClientRect().height) : 0;
      // Drives the sticky offset in kitsters-header.css: the section sits at
      // calc(-1 * var(--kh-ann-h)), which is what lets the ann bar scroll off while
      // the header pins. Measured, not hardcoded - the bar is 36px on desktop, 32px
      // on mobile and 41px at 320px where the copy wraps to two lines, and the owner
      // can change the text in the theme editor at any time.
      section.style.setProperty('--kh-ann-h', h + 'px');
      sentinel.style.top = h + 'px';
    };
    syncAnnHeight();
    if (annBar && 'ResizeObserver' in window) {
      new ResizeObserver(syncAnnHeight).observe(annBar);
    } else {
      window.addEventListener('resize', syncAnnHeight);
    }

    new IntersectionObserver(
      ([e]) => section.classList.toggle('is-scrolled', !e.isIntersecting),
      { threshold: 0 }
    ).observe(sentinel);
  }

  // ── Search placeholder rotation (mobile + desktop inputs) ─────
  const searchInputs = document.querySelectorAll('[data-kh-search-input]');
  if (searchInputs.length) {
    // US terms (2026-09-08). These were India food/craft kits - Cotton Candy, Ice
    // Gola, Tie Dye, Resin Art, Sushi, Lippan Art - none of which this store sells.
    // This list WINS over the placeholder attribute in the markup, so fixing the
    // Liquid alone changed nothing: the first line below overwrites it on load.
    const tips = ['Clay Sculpting Kit', 'Tote Bag Painting Kit', 'Block Printing Kit', 'Handmade Paper Kit', 'Cyanotype Kit', 'Paw Print Keepsake Kit'];
    let ti = 0;
    searchInputs.forEach((el) => { el.placeholder = `Try searching "${tips[0]}"`; });
    setInterval(() => {
      ti = (ti + 1) % tips.length;
      searchInputs.forEach((el) => { el.placeholder = `Try searching "${tips[ti]}"`; });
    }, 3000);
  }

  // ── Desktop search drawer (header search icon) ────────────────
  const searchDrawer = document.querySelector('[data-kh-search-drawer]');
  const searchTog    = document.querySelector('[data-search-toggle]');
  const searchClose  = document.querySelector('[data-kh-search-close]');
  function escCloseSearch(e) { if (e.key === 'Escape') closeSearchDrawer(); }
  function onDocClickSearch(e) {
    if (!searchDrawer || searchDrawer.hidden) return;
    if (!searchDrawer.contains(e.target) && !searchTog?.contains(e.target)) closeSearchDrawer();
  }
  function openSearchDrawer() {
    if (!searchDrawer) return;
    searchDrawer.hidden = false;
    requestAnimationFrame(() => searchDrawer.classList.add('is-open'));
    searchTog?.setAttribute('aria-expanded', 'true');
    searchDrawer.querySelector('.kh-search__input')?.focus();
    document.addEventListener('keydown', escCloseSearch);
    document.addEventListener('click', onDocClickSearch);
  }
  function closeSearchDrawer() {
    if (!searchDrawer) return;
    searchDrawer.classList.remove('is-open');
    const inp = searchDrawer.querySelector('.kh-search__input');
    if (inp) inp.value = '';
    searchTog?.setAttribute('aria-expanded', 'false');
    setTimeout(() => { searchDrawer.hidden = true; }, 250);
    document.removeEventListener('keydown', escCloseSearch);
    document.removeEventListener('click', onDocClickSearch);
    searchTog?.focus();
  }
  searchTog?.addEventListener('click', (e) => {
    e.preventDefault();
    if (searchDrawer && searchDrawer.hidden) openSearchDrawer();
    else closeSearchDrawer();
  });
  searchClose?.addEventListener('click', closeSearchDrawer);

  // ── Focus trap utility ────────────────────────────────────────
  function createFocusTrap(container) {
    const sel = 'a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])';
    function handle(e) {
      if (e.key !== 'Tab') return;
      const items = Array.from(container.querySelectorAll(sel)).filter(
        (el) => !el.hidden && !el.closest('[hidden]')
      );
      if (!items.length) return;
      const first = items[0];
      const last  = items[items.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
    return {
      activate()   { container.addEventListener('keydown', handle); },
      deactivate() { container.removeEventListener('keydown', handle); },
    };
  }

  // ── Mobile overlay ────────────────────────────────────────────
  const openBtn  = document.querySelector('[data-kh-menu-open]');
  const closeBtn = document.querySelector('[data-kh-menu-close]');
  const drawer   = document.querySelector('[data-kh-menu-drawer]');
  const overlay  = document.querySelector('[data-kh-menu-overlay]');
  const backBtn  = document.querySelector('[data-kh-back]');
  const panels   = document.querySelector('[data-kh-panels]');

  const trap = drawer ? createFocusTrap(drawer) : null;

  function openMenu() {
    if (!drawer) return;
    drawer.hidden = false;
    overlay?.classList.add('is-open');
    openBtn?.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    document.body.classList.add('kh-menu-open');
    trap?.activate();
    requestAnimationFrame(() => {
      // preventScroll: focusing must never scroll the panels stage sideways
      drawer.querySelector('input, button, a')?.focus({ preventScroll: true });
    });
  }

  function closeMenu() {
    if (!drawer) return;
    drawer.hidden = true;
    overlay?.classList.remove('is-open');
    openBtn?.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    document.body.classList.remove('kh-menu-open');
    trap?.deactivate();
    // Reset panels to main when closing
    resetPanels();
    openBtn?.focus();
  }

  openBtn?.addEventListener('click', openMenu);
  closeBtn?.addEventListener('click', closeMenu);
  overlay?.addEventListener('click', closeMenu);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeMenu(); });

  // ── Push navigation ───────────────────────────────────────────
  let prevPanel    = null;
  let activePanel  = document.getElementById('kh-panel-main');

  function pushPanel(targetId) {
    const target = document.getElementById(targetId);
    if (!target || !activePanel) return;
    // A sub-panel keeps its scroll position between visits, so going back and
    // re-opening the same submenu dropped you mid-list instead of at its heading
    // (measured: scrollTop still 400 on re-entry). Always enter a panel at the top.
    target.scrollTop = 0;
    activePanel.classList.remove('is-active');
    activePanel.classList.add('is-prev');
    target.classList.add('is-active');
    prevPanel   = activePanel;
    activePanel = target;
    if (backBtn) backBtn.hidden = false;
    // Focus first interactive element in new panel.
    // preventScroll is REQUIRED: without it the browser scrolls the overflow
    // panels stage sideways to reach the still-mid-transition (off-screen) panel,
    // leaving scrollLeft stuck at one panel width so the WRONG submenu shows.
    requestAnimationFrame(() => {
      target.querySelector('a, button')?.focus({ preventScroll: true });
    });
  }

  function popPanel() {
    if (!prevPanel || !activePanel) return;
    const returning = prevPanel;
    // Sub-panel slides out to the right (is-active removed → back to translateX(100%))
    activePanel.classList.remove('is-active');
    // Add is-active to the returning panel BEFORE removing is-prev.
    // Because is-active comes after is-prev in the CSS, it wins the cascade and
    // the transition fires from translateX(-100%) → translateX(0) - correct back direction.
    returning.classList.add('is-active');
    activePanel = returning;
    prevPanel   = null;
    if (backBtn) backBtn.hidden = true;
    // Clean up is-prev once the transition finishes (panel is now visible at 0)
    setTimeout(() => returning.classList.remove('is-prev'), 400);
    requestAnimationFrame(() => {
      returning.querySelector('button, a')?.focus({ preventScroll: true });
    });
  }

  function resetPanels() {
    if (!panels) return;
    panels.querySelectorAll('.kh-mob__panel').forEach((p) => {
      p.classList.remove('is-active', 'is-prev');
    });
    const main = document.getElementById('kh-panel-main');
    if (main) {
      main.classList.add('is-active');
      main.scrollTop = 0;
    }
    activePanel = main;
    prevPanel   = null;
    if (backBtn) backBtn.hidden = true;
  }

  // Wire push buttons
  panels?.querySelectorAll('[data-kh-push]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const targetId = btn.getAttribute('data-kh-push');
      if (targetId) pushPanel(targetId);
    });
  });

  backBtn?.addEventListener('click', popPanel);

  // ── Cmd/Ctrl+K opens search ───────────────────────────────────
  document.addEventListener('keydown', (e) => {
    if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
      e.preventDefault();
      const searchToggle = document.querySelector('[data-search-toggle]');
      if (searchToggle) {
        searchToggle.click();
      }
    }
  });

  // ── Desktop dropdown - arrow key navigation ───────────────────
  document.querySelectorAll('.kh-hdr__nav-item.has-children').forEach((item) => {
    const links = () => Array.from(item.querySelectorAll('.kh-hdr__megapanel a'));
    item.addEventListener('keydown', (e) => {
      const items = links();
      const idx   = items.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        items[Math.min(idx + 1, items.length - 1)]?.focus();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        if (idx <= 0) {
          item.querySelector('.kh-hdr__nav-link')?.focus();
        } else {
          items[idx - 1]?.focus();
        }
      } else if (e.key === 'Escape') {
        item.querySelector('.kh-hdr__nav-link')?.focus();
      }
    });
  });

  // ── Cart count + badge bounce ─────────────────────────────────
  function syncCart(count) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count > 0 ? String(count) : '';
      el.classList.toggle('is-empty', count === 0);
      if (count > 0) {
        el.classList.add('is-bumped');
        setTimeout(() => el.classList.remove('is-bumped'), 300);
      }
    });
    document.querySelectorAll('[data-cart-link]').forEach((el) => {
      el.setAttribute('aria-label', `Cart - ${count} ${count === 1 ? 'item' : 'items'}`);
    });
  }

  // The theme's own cart:update payload is {cartData, source, actionAfterATC} -
  // it carries no item count, so the old `?? 0` fallback BLANKED the badge on
  // every add-to-cart instead of incrementing it. Read a count only when one is
  // genuinely present; otherwise ask /cart.js for the real number.
  let cartSyncInFlight = false;
  function syncCartFromServer() {
    if (cartSyncInFlight) return;
    cartSyncInFlight = true;
    fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
      headers: { Accept: 'application/json' },
    })
      .then((r) => r.json())
      .then((cart) => syncCart(Number(cart.item_count) || 0))
      .catch(() => {})
      .finally(() => { cartSyncInFlight = false; });
  }

  document.addEventListener('cart:update', (e) => {
    const count = e.detail?.cart?.item_count ?? e.detail?.item_count;
    if (typeof count === 'number' && !Number.isNaN(count)) { syncCart(count); return; }
    syncCartFromServer();
  });

  // Authoritative: the cart drawer fires this with the real count once it has
  // re-rendered (see CartCountEvent in assets/events.js).
  document.addEventListener('cart:count:update', (e) => {
    const count = Number(e.detail?.item_count);
    if (!Number.isNaN(count)) syncCart(count);
  });

  // ── Cart drawer intercept ─────────────────────────────────────
  // MUST go through <Kalles' cart drawer>.open(), never a raw dialog.showModal().
  //
  // Kalles' DrawerComponent builds its slide transform in the `show` getter
  // (`this.transform = this.pos`) that open() calls. A raw showModal() skips
  // that getter, so the transform array stays undefined - and the NEXT close
  // (clicking outside the drawer, or the X) throws
  // "Cannot read properties of undefined (reading 'reverse')" inside
  // animateDialogClose(), *after* it has already added .dialog-closing and
  // *before* it reaches dialog.close(). The drawer then slides off screen while
  // still being an open modal <dialog> in the top layer: the page looks normal
  // and nothing on it can be clicked. open() also does the bookkeeping the raw
  // call skipped - html[scroll-lock] and the open-dialog stack - so the lock is
  // released on close instead of leaking.
  function openCartDrawer() {
    const dialog = document.getElementById('CartDrawer');
    if (!dialog) return false; // no drawer on this page - let the link go to /cart

    // Mid-close, open() would be swallowed. `dialog.open` stays true for the
    // ~400ms the exit animation runs, and DialogComponent.open() early-returns
    // on it - so "dismiss the drawer, immediately tap the cart icon" did
    // nothing and the shopper had to tap twice. Queue the open for when the
    // close actually lands. (Kalles dispatches dialog:close on the dialog
    // itself, as does the stuck-drawer watchdog in kitsters-cart-drawer.js.)
    if (dialog.open && dialog.classList.contains('dialog-closing')) {
      let done = false;
      const run = () => {
        if (done) return;
        done = true;
        clearTimeout(timer);
        dialog.removeEventListener('dialog:close', run);
        if (!dialog.open) openCartDrawerNow(dialog);
      };
      dialog.addEventListener('dialog:close', run);
      const timer = setTimeout(run, 800); // in case the event never lands
      return true;
    }
    return openCartDrawerNow(dialog);
  }

  function openCartDrawerNow(dialog) {
    const comp = dialog.closest('cart-drawer');
    if (comp && typeof comp.open === 'function') {
      comp.open();
      return true;
    }
    // Custom element not upgraded yet (its module is still parsing). Wait for
    // it rather than reaching for showModal, with a short raw fallback so a
    // click can never be swallowed. kitsters-cart-drawer.js's watchdog covers
    // the raw branch.
    if (comp && window.customElements) {
      let settled = false;
      const raw = () => {
        if (settled) return;
        settled = true;
        if (!dialog.open) dialog.showModal();
      };
      customElements.whenDefined('cart-drawer').then(() => {
        if (settled) return;
        settled = true;
        if (typeof comp.open === 'function') comp.open();
        else if (!dialog.open) dialog.showModal();
      });
      setTimeout(raw, 500);
      return true;
    }
    if (!dialog.open) dialog.showModal();
    return true;
  }

  document.querySelectorAll('[data-kh-cart-open]').forEach((el) => {
    el.addEventListener('click', (e) => {
      if (openCartDrawer()) e.preventDefault();
    });
  });

})();

// ── Predictive search autocomplete ────────────────────────────
(function () {
  var debounceTimer;

  function buildHTML(products) {
    if (!products || !products.length) return '';
    return products.map(function (p) {
      var img = p.featured_image && p.featured_image.url
        ? '<img src="' + p.featured_image.url + '&width=60" alt="" width="44" height="44" loading="lazy" style="width:44px;height:44px;object-fit:cover;border-radius:6px;border:1px solid #e0e0e0">'
        : '<div style="width:44px;height:44px;background:#f5f5f5;border-radius:6px;flex-shrink:0"></div>';
      function fmt(n) { return window.KitstersMoney.formatMajor(n); }
      var price       = p.price ? fmt(p.price) : '';
      var compareAt   = p.compare_at_price_min && +p.compare_at_price_min > +p.price ? fmt(p.compare_at_price_min) : '';
      var priceHTML   = price
        ? (compareAt
            ? '<span class="kh-suggest__price">' + price + '</span><span class="kh-suggest__compare">' + compareAt + '</span>'
            : '<span class="kh-suggest__price">' + price + '</span>')
        : '';
      return '<a href="' + p.url + '" class="kh-suggest__item">' +
        img +
        '<span class="kh-suggest__info"><span class="kh-suggest__title">' + p.title + '</span>' +
        (priceHTML ? '<span class="kh-suggest__prices">' + priceHTML + '</span>' : '') +
        '</span></a>';
    }).join('');
  }

  /* Restricted vendor (docs/19 MH-VIS). Magic Hour kits are ACTIVE so Razorpay
     Magic Checkout accepts them, which also puts them in Shopify's search index.
     suggest.json is fetched by the browser, so Liquid cannot filter it - the
     vendor comes from the <meta> theme.liquid writes from the same theme
     setting every server-side surface reads. No meta = restriction off. */
  function hiddenVendor() {
    var m = document.querySelector('meta[name="kt-hidden-vendor"]');
    return m ? m.getAttribute('content') : '';
  }

  function fetchSuggestions(q, drop) {
    if (!q || q.length < 2) { drop.innerHTML = ''; drop.hidden = true; return; }
    /* Over-fetch: 5 is the number we SHOW, and a restricted hit would otherwise
       silently cost the shopper a suggestion. */
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=10')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        var hv = hiddenVendor();
        if (hv) {
          products = products.filter(function (p) { return p.vendor !== hv; });
        }
        products = products.slice(0, 5);
        var html = buildHTML(products);
        drop.innerHTML = html;
        drop.hidden = !html;
      })
      .catch(function () { drop.hidden = true; });
  }

  function attachAutosuggest(input) {
    if (!input || input.dataset.suggestAttached) return;
    input.dataset.suggestAttached = '1';
    var wrap = input.parentNode;
    if (getComputedStyle(wrap).position === 'static') wrap.style.position = 'relative';
    var drop = document.createElement('div');
    drop.className = 'kh-suggest';
    drop.hidden = true;
    wrap.appendChild(drop);

    input.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () { fetchSuggestions(input.value.trim(), drop); }, 230);
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { drop.innerHTML = ''; drop.hidden = true; }
    });
    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) { drop.innerHTML = ''; drop.hidden = true; }
    }, true);
  }

  document.addEventListener('DOMContentLoaded', function () {
    var desktopInput = document.querySelector('[data-kh-search-drawer] .kh-search__input');
    if (desktopInput) attachAutosuggest(desktopInput);
    var mobileInput = document.querySelector('[data-kh-menu-drawer] .kh-mob__search-input');
    if (mobileInput) attachAutosuggest(mobileInput);
  });

  // Inject CSS for autocomplete dropdown
  var s = document.createElement('style');
  s.textContent = '.kh-suggest{position:absolute;top:calc(100% + 2px);left:0;right:0;z-index:300;background:#fff;border:2px solid #0a0a0a;border-radius:12px;box-shadow:3px 3px 0 #0a0a0a;overflow:hidden;max-height:320px;overflow-y:auto}' +
    '.kh-suggest__item{display:flex;align-items:center;gap:12px;padding:10px 14px;text-decoration:none;color:#0a0a0a;border-bottom:1px solid #f0f0f0;transition:background 100ms}' +
    '.kh-suggest__item:last-child{border-bottom:none}.kh-suggest__item:hover{background:#f5f5f5}' +
    '.kh-suggest__info{display:flex;flex-direction:column;gap:2px;min-width:0}' +
    '.kh-suggest__title{font-size:14px;font-weight:600;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
    '.kh-suggest__prices{display:flex;align-items:center;gap:6px}' +
    '.kh-suggest__price{font-size:12px;color:#465ae6;font-weight:700}' +
    '.kh-suggest__compare{font-size:11px;color:#5c5c5c;text-decoration:line-through}';
  document.head.appendChild(s);

  // The India build carried a patchWishlistIcons() here, plus the readyState
  // dance that scheduled it. Its only job was to neutralise Kalles' own wishlist
  // icon swap by blanking that vendor's icon settings — nothing swaps icons on
  // this theme, so both the function and its scheduling are deleted rather than
  // ported. The [action] attribute toggle is the whole mechanism now; see
  // assets/kitsters-wishlist-element.js.

})();
